import { useEffect, useRef } from 'react';
import { useRouter } from 'next/router';
import { PREVIOUS_PATH_KEY } from './usePreviousPath';

export const useKeepScrollPosition = (sessionStorageItem, path) => {
  const containerRef = useRef(null);
  const router = useRouter();

  // Restore or reset scroll on mount / route change
  useEffect(() => {
    if (!containerRef.current) return;

    const saved = sessionStorage.getItem(sessionStorageItem);
    const prevPath = sessionStorage.getItem(PREVIOUS_PATH_KEY);
    const isListPage = router.asPath.startsWith(path);
    const cameFromItemPage =
      prevPath && prevPath.startsWith(`${path}/`) && prevPath !== path;

    if (isListPage) {
      containerRef.current.scrollTop =
        cameFromItemPage && saved ? parseInt(saved, 10) : 0;
    }
  }, [sessionStorageItem, router.asPath, path]);

  // Continuously save scroll position
  useEffect(() => {
    const el = containerRef.current;
    if (!el) return;

    const handleScroll = () => {
      sessionStorage.setItem(sessionStorageItem, String(el.scrollTop));
    };

    el.addEventListener('scroll', handleScroll);
    return () => {
      el.removeEventListener('scroll', handleScroll);
    };
  }, [sessionStorageItem]);

  return { containerRef };
};
